import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "14",
      height: "14",
      x: "1",
      y: "1",
      stroke: "currentColor",
      "stroke-width": "2",
      rx: "7"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 0q.508.002 1 .063v15.873A8 8 0 1 1 8 0"
    }, null, -1)
  ]))]))
}
export default { render: render }